import { RouterProvider } from 'react-router-dom';

// project imports
import router from 'routes';
import ThemeCustomization from 'themes';

import Locales from 'components/Locales';
import RTLLayout from 'components/RTLLayout';
import ScrollTop from 'components/ScrollTop';
import Snackbar from 'components/@extended/Snackbar';
import Notistack from 'components/third-party/Notistack';
import Metrics from 'metrics';
import PWAUpdatePrompt from 'components/PWAUpdatePrompt';
import FullscreenBar from 'components/FullscreenBar';

// locale provider (separated from config to avoid full-tree re-renders on language change)
import { LocaleProvider } from 'contexts/LocaleContext';

// auth-provider
import { JWTProvider as AuthProvider } from 'contexts/JWTContext';

// data fetching
import { QueryProvider } from 'contexts/QueryProvider';

// offline support
import { OfflineProvider } from 'contexts/OfflineContext';

// import { FirebaseProvider as AuthProvider } from 'contexts/FirebaseContext';
// import { Auth0Provider as AuthProvider } from 'contexts/Auth0Context';
// import { AWSCognitoProvider as AuthProvider } from 'contexts/AWSCognitoContext';
// import { SupabseProvider as AuthProvider } from 'contexts/SupabaseContext';

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

export default function App() {
  return (
    <>
      <LocaleProvider>
        <ThemeCustomization>
          <RTLLayout>
            <Locales>
            <ScrollTop>
              <QueryProvider>
                <OfflineProvider>
                  <AuthProvider>
                    <>
                      <Notistack>
                        <RouterProvider router={router} />
                        <Snackbar />
                        <PWAUpdatePrompt />
                        <FullscreenBar />
                      </Notistack>
                    </>
                  </AuthProvider>
                </OfflineProvider>
              </QueryProvider>
            </ScrollTop>
            </Locales>
          </RTLLayout>
        </ThemeCustomization>
      </LocaleProvider>
      <Metrics />
    </>
  );
}
